import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Card, Form, Button, Input, message, DatePicker } from "antd";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import {
  req_edit_pim_staff_need_sign,
  req_list_pim_staff_need_sign_Open,
} from "../../api";
class BackfillSetupOpenModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
  };
  state = {
    loading: false,
    lock: false,
    data: [],
    setStaffCode: "",
    setClockDate: "",
  };

  ////////////////////////////////////////////////////////////
  api_item_list = async () => {
    const { setStaffCode } = this.state;
    const { token } = this.props.user;
    const result = await req_list_pim_staff_need_sign_Open(setStaffCode, token);
    if (result.total > 0) {
      const items = result.data;
      this.setState({
        data: items,
        loading: false,
      });
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }
  };

  api_edit_item = async () => {
    const { setStaffCode, setClockDate } = this.state;
    const { token } = this.props.user;
    const item = {
      StaffCode: setStaffCode.toLocaleUpperCase(),
      ClockDate: setClockDate,
      RetroactiveStatus: "OPEN",
      condition: "BACKFILL",
    };
    const result = await req_edit_pim_staff_need_sign(item, token);
    if (result.status === "success") {
      message.success(result.message);
      this.api_item_list();
    } else {
      this.setState({ loading: false });
      message.error(result.message);
    }
  };

  ///////////////////////////////////////////////////////////
  onFinish = async (values) => {
    console.log("data:", values);
    const { setClockDate } = this.state;
    this.setState({ loading: true });
    this.setState({ setStaffCode: values.setStaffCode });
    this.setState({ setClockDate: setClockDate });
    console.log(setClockDate);
    if (setClockDate.length !== 8) {
      message.error("日期格式錯誤");
      this.setState({ loading: false });
      return;
    } else {
      await this.api_edit_item();
    }
  };

  ////////////////////////////////////////////////////////////
  render() {
    const { data, loading, setStaffCode } = this.state;
    const columns = [
      {
        title: "職號",
        dataIndex: "StaffCode",
        key: "StaffCode",
      },
      {
        title: "姓名",
        dataIndex: "StaffName",
        key: "StaffName",
      },
      {
        title: "開放補登日期",
        dataIndex: "ClockDate",
        key: "ClockDate",
      },
    ];
    return (
      <Card>
        <Form onFinish={this.onFinish} layout="inline">
          <Form.Item
            label="職工編號"
            name="setStaffCode"
            initialValue={setStaffCode}
            rules={[
              {
                required: true,
                whitespace: true,
                message: "須填職號",
              },
            ]}
          >
            <Input placeholder="輸入職號" maxLength={6} />
          </Form.Item>
          <Form.Item label="開放日期">
            <DatePicker
              format="YYYYMMDD"
              placeholder="須填開放日期"
              onChange={(e) =>
                this.setState({ setClockDate: dayjs(e).format("YYYYMMDD") })
              }
            ></DatePicker>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              解鎖
            </Button>
          </Form.Item>
        </Form>
        <Table
          bordered
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
          scroll={{
            y: 55 * 5,
          }}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(BackfillSetupOpenModal);
